import axios from 'axios';

export const fetchSystemSettingsSuccess = (settings) => ({
  type: 'FETCH_APPLICATION_SETTINGS_SUCCESS',
  payload: settings
});

export const fetchSystemSettings = (params) => dispatch => {
  return axios.get('/settings')
    .then(response => {
      dispatch(fetchSystemSettingsSuccess(response.data || {}));
    })
    .catch(error => {
      throw(error);
    });
};





// WEBPACK FOOTER //
// ./app/javascript/app/actions/initial_actions.js